
import { defineComponent, ref, onMounted, computed } from "vue";

import Comments from "@/components/Comments.vue";

export default defineComponent({
  name: "Feed",
  components: {
    "comments-component": Comments,
  },
  setup() {
    onMounted(async () => {});

    return {};
  },
});
